import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/helpers/services/notification.service';
import { PublicService } from 'src/app/helpers/services/public.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {

  previousUrl: string | null;
  constructor(private publicService: PublicService, private router: Router, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.publicService.getDeviceId();
    this.notificationService.requestPermission();

    const lang = localStorage.getItem(`${environment.prefix}-lang`);
    if (!lang) {
      localStorage.setItem(`${environment.prefix}-lang`, 'en');
    }

    this.publicService.onlineStatus.subscribe((isOnline) => {
      if (!isOnline) {
        const currentUrl = this.router.url;
        localStorage.setItem(`${environment.prefix}-previous-url`, currentUrl);
        this.router.navigate(['/error/503']);
      } else {
        const previousUrl = localStorage.getItem(`${environment.prefix}-previous-url`);
        if (previousUrl) {
          this.router.navigateByUrl(previousUrl);
          localStorage.removeItem(`${environment.prefix}-previous-url`);
        }
      }
    });
  }
}
